import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageComponent } from './pages/page.component';
import { AuthenticateGuard } from './guards/authenticate.guard';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: '',
    component: PageComponent,
    canActivate: [AuthenticateGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        canActivate: [],
        loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule),
      },
      {
        path: 'user',
        canActivate: [],
        loadChildren: () => import('./pages/user/user.module').then(m => m.UserModule),
      },
      {
        path: 'clients',
        canActivate: [],
        loadChildren: () => import('./pages/clients/clients.module').then(m => m.ClientsModule),
      },
      {
        path: 'sav',
        canActivate: [],
        loadChildren: () => import('./pages/sav/sav.module').then(m => m.SavModule),
      },
      {
        path: 'national-average',
        canActivate: [],
        loadChildren: () => import('./pages/admin-national-average/admin-national-average.module').then(m => m.AdminNationalAverageModule),
      },
      {
        path: 'cron-logs',
        canActivate: [],
        loadChildren: () => import('./pages/admin-cron-logs/admin-cron-logs.module').then(m => m.AdminCronLogsModule),
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
